/**
 * 栏目类型
 */
export const ColumnTypeList = [
  { value: 1, label: "列表" },
  { value: 2, label: "电话" },
  { value: 3, label: "内容项" },
  { value: 4, label: "列表项一" },
  { value: 5, label: "列表项二" },
  { value: 6, label: "列表项三" }
];

export const ColumnTypeMap = {
  1: "列表",
  2: "电话",
  3: "内容项",
  4: "列表项一",
  5: "列表项二",
  6: "列表项三"
};
